import { inject, Injectable } from '@angular/core';
import { LangService } from 'src/app/shared/services/lang/lang.service';

export interface OverlayNoRowsTemplateConfig {
  noResultsMessage?: string;
  retryMessage?: string;
}

@Injectable({
  providedIn: 'root',
})
export class OverlayNoRowsTemplateService {
  private langService = inject(LangService);

  private labels = this.langService.lang.shared.table;

  getOverlayNoRowsTemplate(config?: OverlayNoRowsTemplateConfig): string {
    let noResultsMessage = this.labels.noRowsOverlay.defaultNoResultsMessage;
    if (config && config.noResultsMessage !== undefined) {
      noResultsMessage = config.noResultsMessage;
    }
    let retryMessage = this.labels.noRowsOverlay.defaultRetryMessage;
    if (config && config.retryMessage !== undefined) {
      retryMessage = config.retryMessage;
    }
    return `
<div class="no-rows-overlay">
  <p class="no-rows-overlay__no-results">${noResultsMessage}</p>
  <p class="no-rows-overlay__try-another-search">${retryMessage}</p>
</div>
  `;
  }
}
